function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getFullUserDetails } from "@common/actions";
import Spinner from "@common/components/Spinner";
import request from "@common/services/request";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS, SUBSCRIPTION } from "@config/constants";
var ContinueSubscription = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ContinueSubscription, Component);
    var _super = _create_super(ContinueSubscription);
    function ContinueSubscription(props) {
        _class_call_check(this, ContinueSubscription);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isContinuationRequestPending: false
        };
        _this.renewSubscription = _this.renewSubscription.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ContinueSubscription, [
        {
            key: "renewSubscription",
            value: /**
     * Set automatic renewal of subscription
     */ function renewSubscription() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, userDetails, toggleComponent, _$getFullUserDetails, i18n, enqueueSnackbar, planId, orderData, response, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.state.isContinuationRequestPending) return [
                                    3,
                                    6
                                ];
                                _this_props = _this.props, userDetails = _this_props.userDetails, toggleComponent = _this_props.toggleComponent, _$getFullUserDetails = _this_props.getFullUserDetails, i18n = _this_props.i18n, enqueueSnackbar = _this_props.enqueueSnackbar;
                                planId = userDetails && userDetails.subscription[0] ? userDetails.subscription[0].planId : null;
                                orderData = {
                                    plan: planId
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                _this.setState({
                                    isContinuationRequestPending: true
                                });
                                return [
                                    4,
                                    request({
                                        method: "put",
                                        url: "users/me/subscription",
                                        data: orderData
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                if (!(response.status === STATUS_CODE_SUCCESS)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _$getFullUserDetails()
                                ];
                            case 3:
                                _state.sent();
                                toggleComponent(SUBSCRIPTION);
                                enqueueSnackbar(i18n.snackbar.continueSubscriptionSuccess, {
                                    variant: SNACKBAR_VARIANT_SUCCESS,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _this.setState({
                                    isContinuationRequestPending: false
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                enqueueSnackbar(i18n.errors["error".concat(error.subcode)], {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _this.setState({
                                    isContinuationRequestPending: false
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, componentName = _this_props.componentName, i18n = _this_props.i18n, toggleComponent = _this_props.toggleComponent, componentMap = _this_props.componentMap;
                var parentProps = componentMap[componentName].parentProps;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "main-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "continue-subscription-wrapper",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "summary",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "paper-card clear light",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "margin-bottom-small",
                                            children: i18n.account.continueSubscriptionDesc
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            children: i18n.account.paymentAvailable
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                classes: {
                                                    label: "ux-button-label"
                                                },
                                                onClick: this.renewSubscription,
                                                className: "button raised send-form-button",
                                                children: this.state.isContinuationRequestPending ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsx(_Fragment, {
                                                    children: i18n.account.confirm
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "modal-footer",
                            children: /*#__PURE__*/ _jsxs(Button, {
                                classes: {
                                    label: "ux-button-label"
                                },
                                onClick: function() {
                                    return toggleComponent(componentMap[componentName].parentComponentName, parentProps);
                                },
                                className: "button-no-background go-back-button raised half-width float-left center-vertical",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-keyboard-arrow-right"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: i18n.account.goBack
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ContinueSubscription;
}(Component);
var mapStateToProps = function(param) {
    var order = param.order;
    return {
        order: order
    };
};
export default withSnackbar(connect(mapStateToProps, {
    getFullUserDetails: getFullUserDetails
})(ContinueSubscription));
